import React from 'react';
import cls from '../../MeasurementsModal/MeasurementsModalBody/UploadImage/UploadImage.module.css';
import classNames from 'classnames';

export const MeasurementsDragZone = () => {
    return (
        <>
            <svg
                className={cls.miniZone}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    className={cls.pathSpecific}
                    d="M12.0001 17.0311C14.021 17.0311 15.6592 15.3928 15.6592 13.372C15.6592 11.3511 14.021 9.71289 12.0001 9.71289C9.97929 9.71289 8.34106 11.3511 8.34106 13.372C8.34106 15.3928 9.97929 17.0311 12.0001 17.0311Z"
                    fill="#C1C4C9"
                />
                <path
                    className={cls.pathSpecific}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.5 9.18164C1.5 7.52479 2.84314 6.18164 4.5 6.18164H19.5C21.1569 6.18164 22.5 7.52479 22.5 9.18164V17.5635C22.5 19.2203 21.1569 20.5635 19.5 20.5635H4.5C2.84314 20.5635 1.5 19.2203 1.5 17.5635V9.18164ZM16.7727 13.3726C16.7727 16.0085 14.6359 18.1454 12 18.1454C9.36411 18.1454 7.22729 16.0085 7.22729 13.3726C7.22729 10.7367 9.36411 8.59987 12 8.59987C14.6359 8.59987 16.7727 10.7367 16.7727 13.3726ZM3.45672 8.66365C3.16677 8.66365 2.93172 8.8987 2.93172 9.18865C2.93172 9.4786 3.16677 9.71365 3.45672 9.71365H5.58853C5.87848 9.71365 6.11353 9.4786 6.11353 9.18865C6.11353 8.8987 5.87848 8.66365 5.58853 8.66365H3.45672Z"
                    fill="#C1C4C9"
                />
                <path
                    className={cls.pathSpecific}
                    d="M7.13184 5.16363C7.13184 3.9687 8.10052 3 9.29547 3H14.7046C15.8995 3 16.8682 3.9687 16.8682 5.16363H7.13184Z"
                    fill="#C1C4C9"
                />
            </svg>
            <span className={classNames(cls.UploadAreaText, cls.miniZone)}>
                {i18next.t('MeasurementsDragZone.return.UploadAreaText')}
            </span>
        </>
    );
};
